/* eslint-disable no-console */
import React, { useContext, useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormHelperText, Grid, Stack, TextField, TextareaAutosize, Typography } from '@mui/material';
import { RxCross2 } from 'react-icons/rx';
import { LanguageContext } from '../../../../../../../libs/Context';
import AutoCompleteSearch from './AutoCompleteSearch';
import { toast } from 'react-toastify';
import { catchErr, s3FileUpload } from '../../../../../../../libs/HelperContent';
import { useSelector } from 'react-redux';
import { IsValidURL, ValidateCharecters, ValidateEmail } from '../../../../../../../libs/Validation';
import Loading from '../../../../../../../components/Common/Loaders/FullWidthLoader/Loading';
import { createSpeakerFunc, editSpeakerFunc } from '../../../../../../actions/meeting_actions';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';

const AddSpeaker = (props) =>
{
	const { handleSpeakerClose, selSpeakDetails, form, from } = props;
	const { language } = useContext(LanguageContext);
	const userData = useSelector((state:any) => state.mysession.session);
	const [ loading, setLoading ] = useState(false);
	const [ createSpeaker, setCreateSpeaker ] = useState<any>({
		profile      : {},
		name         : '',
		email        : '',
		designation  : '',
		organization : '',
		desc         : '',
		linkedInUrl  : '',
		fbUrl        : '',
		xUrl         : '',
		websiteUrl   : '',
		errors       : {}
	});

	useEffect(() =>
	{
		if (selSpeakDetails && Object.keys(selSpeakDetails)?.length > 0)
		{
			setCreateSpeaker({
				profile      : selSpeakDetails?.speakerImage,
				name         : selSpeakDetails?.speakerName,
				email        : selSpeakDetails?.speakerEmail,
				designation  : selSpeakDetails?.designation,
				organization : selSpeakDetails?.organization,
				desc         : selSpeakDetails?.description,
				linkedInUrl  : selSpeakDetails?.linkedinUrl,
				fbUrl        : selSpeakDetails?.facebookUrl,
				xUrl         : selSpeakDetails?.twitterUrl,
				websiteUrl   : selSpeakDetails?.websiteUrl
			});
		}
	}, [ selSpeakDetails ]);

	const handleChange = (e) =>
	{
		const { name, value } = e.target;

		setCreateSpeaker((prev) => ({
			...prev,
			[name] : value
		}));
	};

	const handleClose = () =>
	{
		props?.setSpeakers({
			open              : false,
			selEditSpeakDetls : {}
		});
	};

	const handleFileChange = async (e) =>
	{
		const imgTypes = [ 'image/jpeg', 'image/jpg', 'image/png' ];

		if (e.target.files?.length > 0)
		{
			const file = e.target.files[0];

			const fiveMB = (1024 * 1024) * 5;

			if (file?.size > fiveMB)
			{
				toast.error('Profile should not be more than 5MB', {
					position : toast.POSITION.TOP_RIGHT
				});
			}
			else if (!imgTypes.includes(file?.type))
			{
				toast.error('Accepts only JPEG, JPG PNG', {
					position : toast.POSITION.TOP_RIGHT
				});
			}
			else
			{
				const folderPath = `${userData?.userId}/webinar`;

				const upload:any = await s3FileUpload(file, folderPath);

				if (Object.keys(upload)?.length > 0)
				{
					setCreateSpeaker((prevFiles) => ({
						...prevFiles,
						profile : upload
					}));
				}
			}
		}
	};

	const handleSelEmp = (data) =>
	{
		const linkedUrl = data?.socialMedia?.find((each) => each?.name === 'linkedin');
		const fbUrl = data?.socialMedia?.find((each) => each?.name === 'facebook');
		const twitterUrl = data?.socialMedia?.find((each) => each?.name === 'twitter');

		setCreateSpeaker({
			profile      : { ...data?.profile },
			name         : data?.name ?? '',
			email        : data?.email ?? '',
			designation  : data?.designation ?? '',
			organization : data?.organization ?? '',
			desc         : data?.description ?? '',
			linkedInUrl  : linkedUrl?.url ?? '',
			fbUrl        : fbUrl?.url ?? '',
			xUrl         : twitterUrl?.url ?? '',
			websiteUrl   : ''
		});
	};

	const validateError = () =>
	{
		const errorObj:any = {};

		if (createSpeaker?.name === '')
		{
			errorObj.name = 'Please Fill the Name';
		}

		if (createSpeaker?.email === '')
		{
			errorObj.email = 'Please Fill the Email';
		}

		if (createSpeaker?.name !== '' && !ValidateCharecters(createSpeaker?.name))
		{
			errorObj.name = 'Please Enter Valid Name';
		}

		if (createSpeaker?.email !== '' && !ValidateEmail(createSpeaker?.email))
		{
			errorObj.email = 'Please Enter Valid Email';
		}

		if (createSpeaker?.linkedInUrl && !IsValidURL(createSpeaker?.linkedInUrl)) errorObj.linkedInUrl = 'Please Enter Valid URL';
		if (createSpeaker?.fbUrl && !IsValidURL(createSpeaker?.fbUrl)) errorObj.fbUrl = 'Please Enter Valid URL';
		if (createSpeaker?.xUrl && !IsValidURL(createSpeaker?.xUrl)) errorObj.xUrl = 'Please Enter Valid URL';
		if (createSpeaker?.websiteUrl && !IsValidURL(createSpeaker?.websiteUrl)) errorObj.websiteUrl = 'Please Enter Valid URL';

		return errorObj;
	};

	const createApiBody = () =>
	{
		const body:any = {
			sessionId    : form?._id || form?.id, // webinar id
			speakerName  : createSpeaker?.name,
			speakerImage : {
				name : createSpeaker?.profile?.name,
				key  : createSpeaker?.profile?.key,
				type : createSpeaker?.profile?.type,
				url  : createSpeaker?.profile?.url
			},
			speakerEmail : createSpeaker?.email,
			designation  : createSpeaker?.designation,
			organization : createSpeaker?.organization,
			description  : createSpeaker?.desc,
			linkedinUrl  : createSpeaker?.linkedInUrl,
			facebookUrl  : createSpeaker?.fbUrl,
			twitterUrl   : createSpeaker?.xUrl,
			websiteUrl   : createSpeaker?.websiteUrl
		};

		if (selSpeakDetails?._id)
		{
			body._id = selSpeakDetails._id;
		}

		return body;
	};

	const handleSubmit = async () =>
	{
		try
		{
			const errorObj = validateError();

			if (Object.keys(errorObj)?.length <= 0)
			{
				const body:any = createApiBody();

				setLoading(true);
				const res = selSpeakDetails?._id
					? await editSpeakerFunc(body)
					: await createSpeakerFunc(body);

				if (res?.status)
				{
					const successMessage = `${language?.speaker} ${selSpeakDetails?._id ? language?.updated : language?.created
					} ${language?.sucess}`;

					toast.success(successMessage, {
						position : toast.POSITION.TOP_RIGHT
					});
					setLoading(false);

					handleSpeakerClose(true);
				}
				else
				{
					setLoading(false);

					handleSpeakerClose();
				}
			}
			else
			{
				setCreateSpeaker((prev) => ({
					...prev,
					errors : errorObj
				}));
				setLoading(false);
			}
		}
		catch (error:any)
		{
			catchErr(error);
			// eslint-disable-next-line no-console
			console.log('errror', error);
		}
		setLoading(false);
	};

	const handleDeleteProfile = () =>
	{
		setCreateSpeaker((prev) => ({ ...prev, profile: { key: '', url: '', name: '', type: '' } }));
	};

	return (
		<Dialog
			open={props?.open}
			aria-labelledby='alert-dialog-title'
			aria-describedby='alert-dialog-description'
			fullWidth
			maxWidth='md'
		>
			{loading && <Loading/>}
			<DialogTitle id='alert-dialog-title'>
				<Grid container alignItems={'center'}>
					<Grid item sm={6}>
						<Typography variant='h6' fontWeight='var(--font500)'>
							{language.addspeaker}
						</Typography>
					</Grid>
					<Grid item sm={6}>
						<Stack direction='row' spacing={2} alignItems='center'>
							<AutoCompleteSearch handleSelEmp={handleSelEmp}/>
							<Typography sx={{ cursor: 'pointer' }}><RxCross2 onClick={() => { from === 'webinarDet' ? handleSpeakerClose() : handleClose(); }} fontSize={'var(--pixel24)'}/></Typography>
						</Stack>
					</Grid>
				</Grid>
			</DialogTitle>
			<DialogContent>
				<Grid container flexDirection={'column'} >
					<Grid item display={'flex'} justifyContent={'center'} pb={3}>
						<Stack sx={{ display: 'inline-flex', flex: 'none', flexDirection: 'column', width: 'var(--font100)', height: 'var(--font100)', borderRadius: 'var(--percent50)', overflow: 'hidden', position: 'relative', border: '2px solid var(--primaryColor)' }}>
							{createSpeaker?.profile?.url
								?	<Stack sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
									<label htmlFor='speakerProflie'>
										<Typography sx={{ cursor: 'pointer', width: 'var(--percent100)', height: 'var(--percent100)' }}>
											<img src={createSpeaker?.profile?.url || ''} alt='speaker' style={{ width: 'var(--percent100)', height: 'var(--percent100)', objectFit: 'cover' }}/>
										</Typography>
									</label>
								</Stack>
								: <Stack sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 'var(--pixel4)' }}>
									<Typography sx={{ width: 'var(--pixel60)', height: 'var(--pixel60)' }}>
										<img src='/images/icons/profileImg.svg' alt='Profile-Icon' style={{ width: 'var(--percent100)', height: 'var(--percent100)', objectFit: 'contain' }}/>
									</Typography>
								</Stack>}
							{!createSpeaker?.profile?.url &&
							<label htmlFor='speakerProflie'>
								<Typography
									sx={{ display: 'flex', flex: 'none', flexDirection: 'column', width: 'var(--percent100)', position: 'absolute', zIndex: '10', bottom: '0px', backgroundColor: '#DFF9FF', cursor: 'pointer', justifyContent: 'center' }}
								>
									<img src='/images/icons/camera.svg' alt='' width={'var(--pixel20)'} height={'var(--pixel20)'}/>
								</Typography>
							</label>
							}
							{createSpeaker?.profile?.url &&
							<Typography
								sx={{ display: 'flex', flex: 'none', flexDirection: 'column', width: 'var(--percent100)', position: 'absolute', zIndex: '10', bottom: '0px', backgroundColor: '#DFF9FF', cursor: 'pointer', justifyContent: 'center', alignItems: 'center' }}
								onClick={handleDeleteProfile}
							>
								<DeleteOutlinedIcon width={'var(--pixel20)'} height={'var(--pixel20)'}/>
							</Typography>
							}
						</Stack>
					</Grid>
					<input type='file' id='speakerProflie' accept='image/png, image/jpeg, image/jpg' onChange={handleFileChange} style={{ display: 'none' }} />
					<Grid container pb='var(--pixel16)'>
						<Grid item sm={6} sx={{ paddingRight: 'var(--pixel8)' }}>
							<Stack direction={'column'}>
								<Typography sx={{ paddingBottom: 'var(--pixel4)' }} variant='subtitle2'>{language.name}*</Typography>
								<TextField name='name' value={createSpeaker?.name} onChange={handleChange} placeholder={language.entername} size='small' id='Enter Name'/>
								{createSpeaker?.errors?.name &&
								<FormHelperText
									className='errorTxt'

								>{createSpeaker?.errors?.name}</FormHelperText>}
							</Stack>
						</Grid>
						<Grid item sm={6} sx={{ paddingLeft: 'var(--pixel8)' }}>
							<Stack direction={'column'}>
								<Typography sx={{ paddingBottom: 'var(--pixel4)' }} variant='subtitle2'>{language?.emailID}*</Typography>
								<TextField name='email' value={createSpeaker?.email} onChange={handleChange} placeholder={language.enterEmailId} size='small' id='Enter Email ID' />
								{createSpeaker?.errors?.email &&
								<FormHelperText
									className='errorTxt'

								>{createSpeaker?.errors?.email}</FormHelperText>}
							</Stack>
						</Grid>
					</Grid>
					<Grid container pb='var(--pixel16)'>
						<Grid item sm={6} sx={{ paddingRight: 'var(--pixel8)' }}>
							<Stack direction={'column'}>
								<Typography sx={{ paddingBottom: 'var(--pixel4)' }} variant='subtitle2'>{language.designation}</Typography>
								<TextField name='designation' value={createSpeaker?.designation} onChange={handleChange} placeholder={language.enterDesignation} size='small' id='designation'/>
							</Stack>
						</Grid>
						<Grid item sm={6} sx={{ paddingLeft: 'var(--pixel8)' }}>
							<Stack direction={'column'}>
								<Typography sx={{ paddingBottom: 'var(--pixel4)' }} variant='subtitle2'>{language.organization}</Typography>
								<TextField name='organization' value={createSpeaker?.organization} onChange={handleChange} placeholder={language.enterOrganizationName} size='small' id='Enter Organization' />
							</Stack>
						</Grid>
					</Grid>
					<Grid container pb='var(--pixel16)'>
						<Grid item sm={12}>
							<Stack direction={'column'}>
								<Typography sx={{ paddingBottom: 'var(--pixel4)' }} variant='subtitle2'>{language.description}</Typography>
								<TextareaAutosize
									aria-label='minimum height'
									minRows={2}
									maxLength={100}
									value={createSpeaker?.desc} onChange={handleChange}
									placeholder={language.enterDescript}
									style={{ width: 'var(--percent100)', padding: 'var(--pixel4)', borderRadius: 'var(--pixel4)' }}
									name='desc'
								/>
								<Typography variant='caption' sx={{ justifyContent: 'end', alignItems: 'end', display: 'flex' }}>{`${createSpeaker?.desc?.length}/100`}</Typography>
							</Stack>
						</Grid>
					</Grid>
					<Grid container pb='var(--pixel16)'>
						<Grid item sm={6} sx={{ paddingRight: 'var(--pixel8)' }}>
							<Stack direction={'column'}>
								<Typography sx={{ paddingBottom: 'var(--pixel4)' }} variant='subtitle2'>{language.linkedIn}</Typography>
								<TextField name='linkedInUrl' value={createSpeaker?.linkedInUrl} onChange={handleChange} placeholder={language.enterlinkedinURl} size='small' id='Enter Linked In url'/>
								{createSpeaker?.errors?.linkedInUrl &&
								<FormHelperText
									className='errorTxt'

								>{createSpeaker?.errors?.linkedInUrl}</FormHelperText>}
							</Stack>
						</Grid>
						<Grid item sm={6} sx={{ paddingLeft: 'var(--pixel8)' }}>
							<Stack direction={'column'}>
								<Typography sx={{ paddingBottom: 'var(--pixel4)' }} variant='subtitle2'>{language.facebook}</Typography>
								<TextField name='fbUrl' value={createSpeaker?.fbUrl} onChange={handleChange} placeholder={language.enterfacebookURl} size='small' id='Enter Facebook URL' />
								{createSpeaker?.errors?.fbUrl &&
								<FormHelperText
									className='errorTxt'

								>{createSpeaker?.errors?.fbUrl}</FormHelperText>}
							</Stack>
						</Grid>
					</Grid>
					<Grid container pb='var(--pixel16)'>
						<Grid item sm={6} sx={{ paddingRight: 'var(--pixel8)' }}>
							<Stack direction={'column'}>
								<Typography sx={{ paddingBottom: 'var(--pixel4)' }} variant='subtitle2'>X({language.twitter})</Typography>
								<TextField name='xUrl' value={createSpeaker?.xUrl} onChange={handleChange} placeholder={language.enterTwitterURl} size='small' id='Enter Twitter URL' />
								{createSpeaker?.errors?.xUrl &&
								<FormHelperText
									className='errorTxt'

								>{createSpeaker?.errors?.xUrl}</FormHelperText>}
							</Stack>
						</Grid>
						<Grid item sm={6} sx={{ paddingLeft: 'var(--pixel8)' }}>
							<Stack direction={'column'}>
								<Typography sx={{ paddingBottom: 'var(--pixel4)' }} variant='subtitle2'>{language.website}</Typography>
								<TextField name='websiteUrl' value={createSpeaker?.websiteUrl} onChange={handleChange} placeholder={language.enterwebsitelink} size='small' id='Enter Website link' />
								{createSpeaker?.errors?.websiteUrl &&
								<FormHelperText
									className='errorTxt'

								>{createSpeaker?.errors?.websiteUrl}</FormHelperText>}
							</Stack>
						</Grid>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Stack direction='row' p='var(--pixel16)' alignItems={'center'} display={'flex'}>
					<Button disableElevation disableFocusRipple disableRipple disableTouchRipple variant='outlined' sx={{ textTransform: 'capitalize' }} onClick={() => { from === 'webinarDet' ? handleSpeakerClose() : handleClose(); }}>
						{language.cancel}</Button>
					<Typography pl='var(--pixel16)'>
						<Button disableElevation disableFocusRipple disableRipple disableTouchRipple variant='contained' sx={{ color: 'var(--whiteColor)', textTransform: 'capitalize' }} onClick={handleSubmit}>
							{language.add}
						</Button>
					</Typography>
				</Stack>
			</DialogActions>
		</Dialog>
	);
};

export default AddSpeaker;
